import { useState, useEffect } from 'react';

interface UseTwitterProps {
  isTwitterLoaded: boolean;
}
const useTwitter = (source: string): UseTwitterProps => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = source;
    document.body.appendChild(script);
    script.onload = () => setIsLoaded(true);
  });

  return {
    isTwitterLoaded: isLoaded,
  };
};

export default useTwitter;
